export const TAB_FLAT = 'Для квартиры';
export const TAB_VILLAGE = 'Для частного дома';

export const PATH_BUNDLES_LINK_CITY = '/bundles';
export const PATH_BUNDLES_LINK_VILLAGE = '/bundles/village';
export const PATH_INTERNET_LINK_CITY = '/internet';
